import React from "react";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import * as UserAccountAction from "store/user/account/action";
import Router from "router/router";

import * as Api from "api/api";
import * as antd from "antd";
import * as glx from "components/glx";
import * as css from "./css/login-form";
import {observer, inject} from "mobx-react";
import {useHistory, useLocation} from "react-router-dom";
import useMyStores from "../../hooks/useMyStores";

const LoginForm = ({form, store, user, toRegister}) => {
    const {getFieldDecorator, validateFields, setFieldsValue} = form;
    const doLogin = e => {
        e.preventDefault();
        validateFields(async (err, values) => {
            if (!err) {
                const {username, password} = store;

                try {
                    await Api.login({username, password});

                    antd.message.success("登录成功");
                    await user.login();
                    window.location.reload();
                    store.show = false;
                } catch (error) {
                    const errMsg = error.response.data.msg;
                    antd.message.error(errMsg);
                } finally {
                }
            }
        });
    };
    return (
        <css.Form onSubmit={doLogin}>
            <css.FormItem as={antd.Form.Item} first>
                {getFieldDecorator("input.username", {
                    rules: [
                        {
                            required: true,
                            message: "请输入用户名"
                        }
                    ]
                })(
                    <css.InputBlock>
                        <css.InputIcon src={require("./img/username-icon.png")}/>
                        <css.BgImg src={require("./img/input-img.png")}/>
                        <css.Input
                            placeholder="用户名/邮箱/手机号"
                            value={store.username}
                            onChange={e => {
                                store.username = e.currentTarget.value;
                            }}
                        />
                    </css.InputBlock>
                )}
            </css.FormItem>
            <css.FormItem as={antd.Form.Item}>
                {getFieldDecorator("input.password", {
                    rules: [
                        {
                            required: true,
                            message: "请输入密码"
                        }
                    ]
                })(
                    <css.InputBlock>
                        <css.InputIcon src={require("./img/password-icon.png")}/>
                        <css.BgImg src={require("./img/input-img.png")}/>
                        <css.Input
                            type="password"
                            placeholder="密码"
                            value={store.password}
                            onChange={e => {
                                store.password = e.currentTarget.value;
                            }}
                        />
                    </css.InputBlock>
                )}
            </css.FormItem>
            <css.SaveBlock>
                <css.RegisterText onClick={toRegister}>
                    前往注册
                </css.RegisterText>
                <css.RegisterIcon
                    src={require("./img/register-icon.png")}
                    onClick={toRegister}
                />
            </css.SaveBlock>
            <css.LoginButton>
                <css.BgImg src={require("./img/login-bg.png")}/>
                登录
            </css.LoginButton>
        </css.Form>
    )
}

const WrappedForm = antd.Form.create({name: "login"})(LoginForm);

const Index = ({className}) => {
    const {login: store, user} = useMyStores()

    const history = useHistory();
    const location = useLocation();
    const toRegister = () => {
        history.replace({
            pathname: Router.Register.path
        });
    };

    return (
        <css.LoginForm className={className}>
            <css.BgImg src={require("./img/bg.png")}/>
            <button
                className="close"
                onClick={() => {
                    store.show = false;
                }}
            >
                <div className="bg"></div>
            </button>
            <css.TitleFloor>
                <css.TitleText src={require("./img/title-text.png")}></css.TitleText>
                <css.TitleBgImg src={require("./img/title-bg.png")}/>
            </css.TitleFloor>
            <WrappedForm store={store} user={user} toRegister={toRegister}/>
        </css.LoginForm>
    );
}


export default observer(Index);
